import { ToolsRoutes } from "./names";

import type { AppRouteRecordRaw } from "@/app/router/types/types";

// Last in the list: a Tools URL that matches no page stays inside the Tools layout.
export const notFoundRoutes: AppRouteRecordRaw[] = [
  {
    path: ":pathMatch(.*)*",
    name: ToolsRoutes.NOT_FOUND,
    component: () => import("../../pages/ToolsNotFoundPage.vue"),
    meta: {
      title: "Not Found",
      showInMenu: false,
    },
  },
];
